export default {
  notice: {
    clear: 'Empty All',
    notificationTabName: 'Notifications',
    messageTabName: 'Messages',
    todoTabName: 'Todos',
    done: 'You have viewed all messages',
    more: 'More Info',
  },
};
